<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 
<vue-snotify/>

<div class="columns is-multiline is-gapless is-mobile" style="margin-top:-.8em;margin-left:-.7em;">

<div v-if="!check_mobile()" class="column is-2">
<div class="colBorder" v-for ="(stud, ind) in data_student" :key="randomKey(ind)"> 

<div class="columns is-mobile is-gapless is-vcentered" >
<div class="column is-2">          
<figure class="image is-32x32">
<img class="is-rounded" :src="return_pic(stud.student_PhotoPath)" onerror="javascript:this.src='https://space-zytco.nyc3.digitaloceanspaces.com/photos/noImage.png'" alt="....">
</figure>       
</div>
<div class="column is-10">         
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold" style="">{{stud.student_lNAME}}</div>
        <div class="column is-8 is-size-7" style="margin-top:-.5em;"> {{stud.student_fNAME}}</div>
        <div class="column is-4 is-size-7 has-text-info has-text-right" style="margin-top:-.5em;"> {{stud.student_GRPCODE}}&nbsp;&nbsp;</div>
    </div>
</div></div>
 
</div>
</div><!-- END COLUMN STUDENTS                 -->

<!-- REMOVE BUTTON  -->
<div v-if="!check_mobile()" class="column is-1">
    <div class="colBorder" style="" v-for ="(stud, ind) in data_student" :key="ind"> 
        <a v-if="+stud.goodToGo == true" class="button is-fullwidth has-background-white has-text-success" @click="toggle_send(ind)"><span class="icon is-small"><i class="fas fa-user-plus"></i></span></a>
        <a v-else class="button is-fullwidth has-background-white has-text-danger" @click="toggle_send(ind)"><span class="icon is-small"><i class="fas fa-user-times"></i></span></a>
    </div>
</div><!-- END REMOVE BUTTON-->






 <!-- <div class="column is-1"></div> SPACE -->

<div class="column" :class="return_column_width('is-9','is-12')" style="margin-top:-.8em;">

<div class="columns box is-mobile is-multiline is-gapless has-background-light" style="margin-top:1em;padding:1em;">
    <div class="column is-6 has-text-weight-bold has-text-dark colNotes" :class="return_text_size('is-size-5','is-size-7')">envoyer un message aux étudiants</div>
    <div class="column is-6">
         
<!-- SUBJECT FOR EMAIL ~  -->
    <input  v-model="msg_subject" min="0" 
      class="input is-fullwidth has-text-left has-text-weight-bold" type="text" 
      placeholder="sujet (email)" value="">
    </div>
    <div class="column is-12"><textarea v-model="msg_body" rows="5" class="textarea" placeholder="message ...."></textarea></div>

<div class="column is-12">
<div v-if="check_mobile()" class="columns is-mobile is-gapless">
    <div v-if="check_can_sms()" class="column is-5"><a  class="button is-fullwidth has-background-info has-text-white has-text-weight-bold" @click="send_confirm('SMS')"><span class="icon is-large"><i class="fas fa-sms"></i></span>&nbsp;&nbsp;&nbsp;&nbsp; SMS</a></div>
    <div class="column is-2"></div>  <!-- SPACE  -->
    <div v-if="check_can_email()" class="column is-5"><a  class="button is-fullwidth has-background-info has-text-white has-text-weight-bold" @click="send_confirm('EMAIL')"><span class="icon is-large"><i class="far fa-envelope"></i></span>&nbsp;&nbsp;&nbsp;&nbsp; Email</a></div>
</div>
<div v-else class="columns is-mobile is-gapless">
    <div class="column is-3"></div>  <!-- SPACE  -->
    <div v-if="check_can_sms()" class="column is-4"><a  class="button is-fullwidth has-background-info has-text-white has-text-weight-bold" @click="send_confirm('SMS')"><span class="icon is-large"><i class="fas fa-sms"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;Envoyer SMS</a></div>
    <div class="column is-1"></div>  <!-- SPACE  -->
    <div v-if="check_can_email()" class="column is-4"><a  class="button is-fullwidth has-background-info has-text-white has-text-weight-bold" @click="send_confirm('EMAIL')"><span class="icon is-large"><i class="far fa-envelope"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;Envoyer Email</a></div>
</div>

</div>
    





</div>




<!-- CONFIRMATION  -->
<div v-if="show_confirm == true" class="column is-12"> 
<div class="columns">
    <div class="column is-6 is-size-3 has-text-weight-bold has-text-light">CONFIRM</div>
    <div class="column is-1">
        <button @click="show_confirm=!show_confirm" class="button is-fullwidth has-text-weight-bold" style="background-color:LIGHTCORAL;color:white">
            <span class="icon has-text-left"><i class="fas fa-window-close"></i></span>     
        </button>
    </div>
    <div class="column is-5">
    <a  class="button is-fullwidth has-background-success has-text-white has-text-weight-bold" @click="send_sendIt()"><span class="icon is-large"><i class="fas fa-plane"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;{{msg_confirm_msg}}</a>        
    </div>
</div>
</div>

<div class="columns box is-multiline is-gapless has-background-light" style="margin-top:-1.6em;padding:1em;margin-bottom:-.5em;">
    <div class="column is-12 is-size-5 has-text-right has-text-weight-bold has-text-grey-light ">Historique du message</div>
</div>
<!-- {{moment(data.msgMAIN_DATE).format('MMM do YY   hh:mm')}} -->

<div class="columns is-multiline is-gapless is-size-7" v-for="(data,index) in data_history" :key="index" style="">
    <div class="column has-text-centered is-2 has-background-grey-lighter has-text-weight-bold has-text-dark colBorderThin"> {{format_date(data.msgMAIN_DATE)}}     </div>
    <div class="column is-3 has-background-grey-lighter has-text-weight-bold has-text-dark colBorderThin">&nbsp;&nbsp;{{data.staff}}</div>
    <div class="column has-text-centered is-2 has-background-grey-lighter has-text-weight-bold has-text-dark colBorderThin">{{data.msgMain_TYPE}}</div>
    <div class="column is-5 has-background-grey-lighter has-text-weight-bold has-text-dark colBorderThin">&nbsp;&nbsp;{{data.msgMAIN_SUBJECT}}</div>

    <div style="padding:2em;" class="column is-size-5 is-12 has-text-dark colBorderThin">
        
        
<div class="columns" style="padding:.5em;">
<div class="column is-12">{{data.msgMAIN_MSG}}</div>
</div>

        
    </div>
</div>

    
</div>



</div>
</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
        props: [ 'group_id' ],
        components: {  },

        data() {
            return {
                 isLoading:false,
                 data_student:[],
                 data_history:[],


msg_from : '',
msg_type : '',
msg_confirm_msg : '',
msg_subject:'',
msg_body:'',
msg_body_html:'',
msg_count:0,
msg_addresses: '',
msg_student_ids:'',

show_confirm:false,

            }
        },


created() {

    this.isLoading = true;
    this.data_student = []
    var sql = ` SELECT MyMEQ_STUDENT.*, 1 AS goodToGo FROM  MyMEQ_STUDENT INNER JOIN  MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID
    WHERE MyMEQ_COURSESTUDENT.group_ID = ` + this.group_id + ` ORDER BY student_lNAME `
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
            this.data_student = res.data
            this.get_message_history()

    })

},

methods : {

check_mobile() {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return true} else {return false} 
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return sizeM} else {return sizeD} 
},

check_can_email:function() {
// CHECK IF COLLEGE CAN EMAIL/SMS
    if (sessionStorage.getItem('college_canEMAIL'))
    {return true}
    else {return false}
},
check_can_sms:function() {
// CHECK IF COLLEGE CAN EMAIL/SMS
    if ( sessionStorage.getItem('college_canSMS'))
    {return true}
    else {return false}
},

format_date:function(dt) {
console.log(dt)
    var return_date = moment(dt).format("MMM-DD-YY");
console.log(return_date)    
    var return_time = moment.utc(dt, "HH:mm:ss").add(1, 'h').format("hh:mm A");
    return  return_date + " " + return_time

},

get_message_history:function(showNotify) {
    // GET MSG HiSTORY
    var sql = "SELECT *,MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS staff FROM myMEQ_MSG_MAIN INNER JOIN MyMEQ_STAFF ON myMEQ_MSG_MAIN.staff_ID = MyMEQ_STAFF.staff_ID WHERE group_ID = " + this.group_id + " ORDER BY msgMAIN_ID DESC"
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
        .then(res => { 
                this.data_history = res.data
                this.isLoading = false;

if (showNotify) {
    this.$snotify.success('Saved !!', {
    timeout: 2000,
    showProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true
    });
}

        })
},


send_confirm:function(sendType) {

    this.msg_type = sendType
    this.msg_addresses = ''
    this.msg_student_ids = ''

    if (sendType == 'EMAIL') {if (this.msg_subject.trim() == '') {alert('Enter sujet') ; return;}}
    if (this.msg_body.trim() == '') {alert('Enter message') ; return;}

    this.msg_from = "'" + sessionStorage.getItem('user_name') + "' <" + sessionStorage.getItem('user_email') + ">"

    this.msg_body_html = encodeURIComponent(this.msg_body.replace(/\n/g, "<br />"))
    console.log(this.msg_body_html)


    this.msg_count = 0
    var i; 
    for (i = 0; i < this.data_student.length; i++) {
       if (+this.data_student[i].goodToGo == true) 
       {   this.msg_count = +this.msg_count + 1
           this.msg_addresses += this.data_student[i].student_eMail + ","
           this.msg_student_ids += this.data_student[i].student_ID + ","}
    }
    if (this.msg_type == 'EMAIL') { this.msg_confirm_msg = 'envoyer ' + +this.msg_count + ' courriels'}
    else {this.msg_confirm_msg = 'envoyer ' + +this.msg_count + ' SMS'}

this.show_confirm = true 
},

send_sendIt:function() {
//SEND THAT S*&T
alert(this.msg_type)

//    if (this.msg_type == 'EMAIL') { this.send_email()}
//    else {this.send_sms()}


},

send_sms:function() {

var query = "INSERT INTO myMEQ_MSG_MAIN (group_ID, msgMAIN_DATE,msgMAIN_SUBJECT,msgMAIN_MSG,staff_ID, msgMain_TYPE, msgMain_ATTACH) VALUES (" + this.group_id + ",'" + moment().format('YYYY-MM-DD HH:mm:SS') + "','" + this.msg_subject.replace( "'", "''") + "','" + this.msg_body.replace( "'", "''") + "'," + sessionStorage.getItem('user_ID') + ",'" + this.msg_type + "','" + this.msg_student_ids + "')"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 

    // NEED TO SEND ONE AT A TIME -- 
         var i; 
        for (i = 0; i < this.data_student.length; i++) {
        if (+this.data_student[i].goodToGo == true) 
        { axios.post(this.$url+'/sms_send?msg='+this.msg_body+'&to='+this.data_student[i].student_TelOther)
         .then(res => { console.log(res)})
            }
        } 

        this.show_confirm = false
        this.get_message_history()

})


},


send_email:function() {
    //alert('here')
// STRING CONSTRUCTED ABOVE
    axios.post(this.$url+'/send_email_college?from='+encodeURIComponent(this.msg_from)+'&addresses='+this.msg_addresses+'&subject='+this.msg_subject+'&msgText='+this.msg_body+'&msgHtml='+this.msg_body_html)
    .then(res => { 
        this.show_confirm = false
        this.$snotify.success(' Email Sent !!', {
            timeout: 1000,showProgressBar: true,closeOnClick: false,pauseOnHover: false
        });       
        //this.get_message_history(true)
    })
},


send_email_XX:function() {
// STRING CONSTRUCTED ABOVE

var query = "INSERT INTO myMEQ_MSG_MAIN (group_ID, msgMAIN_DATE,msgMAIN_SUBJECT,msgMAIN_MSG,staff_ID, msgMain_TYPE, msgMain_ATTACH) VALUES (" + this.group_id + ",'" + moment().format('YYYY-MM-DD HH:mm:SS') + "','" + this.msg_subject.replace( "'", "''") + "','" + this.msg_body.replace( "'", "''") + "'," + sessionStorage.getItem('user_ID') + ",'" + this.msg_type + "','" + this.msg_student_ids + "')"
console.log(query)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    console.log(res)
    //axios.get(this.$url+'/send_email_' + sessionStorage.getItem('college_nickname') + '?from='+encodeURIComponent(this.msg_from)+'&addresses='+this.msg_addresses+'&subject='+this.msg_subject+'&msgText='+this.msg_body+'&msgHtml='+this.msg_body_html)
    axios.get(this.$url+'/send_email_college?from='+encodeURIComponent(this.msg_from)+'&addresses='+this.msg_addresses+'&subject='+this.msg_subject+'&msgText='+this.msg_body+'&msgHtml='+this.msg_body_html)
    .then(res => { 
        this.show_confirm = false
        this.get_message_history(true)
    })
})



},

toggle_send:function(index) {
    this.data_student[index].goodToGo = !+this.data_student[index].goodToGo
},



return_pic:function(pic) {
    return 'https://space-zytco.nyc3.digitaloceanspaces.com/photos/'+pic
},
// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},

}, // END METHODS


}
</script>
